import React, { createContext, useContext, useState } from "react";

const PagesContext = createContext();

export const usePages = () => useContext(PagesContext);

export const PagesProvider = ({ children }) => {
  const [pages, setPages] = useState([]);

  return (
    <PagesContext.Provider value={[pages, setPages]}>
      {children}
    </PagesContext.Provider>
  );
};
